<template>
  <div
    class="leo-flex leo-flex-col leo-justify-between leo-items-center leo-min-h-screen"
  >
    <div>
      <Header />
    </div>
    <div
      class="leo-z-1 leo-container leo-flex leo-flex-col leo-justify-items-start leo-h-full desktop:leo-h-auto leo-w-full leo-relative leo-flex-grow"
    >
      <!-- Add some flag here that checks for presence of requestID -->
      <refresh-page v-if="renderRefresh" />
      <alert class="tablet:leo-mt-xl tablet:leo--mb-xl" />
      <main class="leo-flex leo-flex-col leo-justify-between leo-flex-grow">
        <div class="leo-row tablet:leo-gap-md tablet:leo-py-7xl leo-flex-grow">
          <div :class="[isDesktopChannel ? 'leo-col-12 tablet:leo-col-4 tablet:leo-offset-2 desktop:leo-col-6 desktop:leo-offset-3' : 'leo-col-12 tablet:leo-px-3xl']">
            <div
              v-if="isChangePasswordFlow"
              class="leo-text-2xl leo-mx-xl leo-text-secondary leo-font-semibold leo-pb-2xl"
            >
              Change Password
            </div>
            <leo-card
              class="leo-rounded-none leo-shadow-none leo-h-full tablet:leo-rounded-md tablet:leo-px-xl tablet:leo-shadow-4 desktop:leo-mx-xl tablet:leo-h-auto"
            >
              <slot />
            </leo-card>
          </div>
        </div>
      </main>
    </div>
    <div
      class="leo-hidden tablet:leo-block leo-z-0 leo-fixed leo-bottom-0 leo-flex leo-flex-col leo-items-stretch leo-justify-end"
      v-if="isDesktopChannel"
    >
      <img src="../assets/images/GreatID_Image_BG.svg" alt="Sign In Background Image" />
    </div>
    <div class="leo-z-1 leo-row leo-hidden tablet:leo-flex leo-w-screen" v-if="isDesktopChannel">
      <Footer />
    </div>
  </div>
</template>
<script>
import { Header, Footer } from "@/components";
import { mapGetters } from "vuex";
import sessionStorageUtils from "@/utils/session-storage";
import { CommonClass } from "@/mixins";
import Alert from "@/components/base/alert/Alert";
import RefreshPage from "@/components/base/refresh/RefreshPage";
import { VueLeoCard } from "@greateasternlife/leo-card";
export default {
  name: "LayoutDefault",
  components: {
    Header,
    Footer,
    alert: Alert,
    "refresh-page": RefreshPage,
    "leo-card": VueLeoCard,
  },
  mixins: [CommonClass],
  data() {
    return {
      isamrequestId: null,
    };
  },
  computed: {
    ...mapGetters("user", ["getData"]),
    isDesktopChannel() {
        return this.$__checkIsDesktopChannel();
    },
    requestID() {
      const sessionRequestId = sessionStorageUtils.getItem("requestID");
      console.log(
        "this.requestId",
        this.isamrequestId,
        "this.getData.requestID",
        this.getData?.requestID,
        "sessionRequestId",
        sessionRequestId
      );
      return this.isamrequestId || this.getData?.requestID || sessionRequestId;
    },
    flowName() {
      return this.getData?.flowName;
    },
    renderRefresh() {
      console.log("renderRefresh", this.requestID);
      return this.requestID;
    },
    isChangePasswordFlow() {
      return this.$route.path.includes("/change-password");
    },
  },
  watch: {
    $route: {
      handler() {
        // if (this.$route.query?.requestId) {
        //   sessionStorageUtils.setItem(
        //     "requestID",
        //     this.$route.query?.requestId
        //   );
        //   this.isamrequestId = this.$route.query?.requestId;
        // } else {
        //   this.isamrequestId = null;
        // }
        console.log('reqest', this.$__checkAppCountry())
        this.isamrequestId = this.$__checkRequestIdISAM();
        if (this.isamrequestId) {
          sessionStorageUtils.setItem("requestID", this.isamrequestId);
        } else {
          this.isamrequestId = null;
        }
      },
    },
  },
};
</script>
